import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";

export const GetOneProjectManagementTeamMembers = createAsyncThunk(
  "OneProjectManagementTeamMembers/OneGetProjectManagementTeamMembers",
  async (tE_ProjectManagementTeamMembersId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/TE_PM_ProjectManagementTeamMembers/GetTE_PM_ProjectManagementTeamMembersData",
        {
          tE_ProjectManagementTeamMembersId: tE_ProjectManagementTeamMembersId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ValidateProjectManagementTeamMembers = createAsyncThunk(
  "ProjectManagementTeamMembers/ValidateProjectManagementTeamMembers",
  async (ProjectManagementTeamMembers, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/TE_PM_ProjectManagementTeamMembers/ValidateTE_PM_ProjectManagementTeamMembersData",
        {
          fourPartName: ProjectManagementTeamMembers.fourPartName,
          gender: ProjectManagementTeamMembers.gender,
          tE_PM_NatureOfWorkId:
            ProjectManagementTeamMembers.tE_PM_NatureOfWorkId,
          tE_PM_TypeOfWorkId: ProjectManagementTeamMembers.tE_PM_TypeOfWorkId,
          idDocumentAttachment: ProjectManagementTeamMembers.idDocumentAttachment,
          cvDocumentAttachment: ProjectManagementTeamMembers.cvDocumentAttachment,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      if (response.data.success === true) {
        const arrayValidate = response.data.result.map((ele, ind) => {
          return ele.code;
        });
        return arrayValidate; // Return the extracted data
      }
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const OneProjectManagementTeamMembers = createSlice({
  name: "OneProjectManagementTeamMembers",
  initialState: {
    OneProjectManagementTeamMembers: {},
    loadingOneProjectManagementTeamMembers: false,
    errorOneProjectManagementTeamMembers: null,

    OneProjectManagementTeamMembersValidate: [],
    loadingOneProjectManagementTeamMembersValidate: false,
    errorOneOneProjectManagementTeamMembersValidate: null,
  },
  reducers: {
    restValidateProjectManagementTeamMembers : (state,action)=>{
      state.OneProjectManagementTeamMembersValidate = [];
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetOneProjectManagementTeamMembers.pending, (state, action) => {
        state.loadingOneProjectManagementTeamMembers = true;
        state.OneProjectManagementTeamMembers = action.payload;
        state.errorOneProjectManagementTeamMembers = null;
      })
      .addCase(
        GetOneProjectManagementTeamMembers.fulfilled,
        (state, action) => {
          state.loadingOneProjectManagementTeamMembers = false;
          state.OneProjectManagementTeamMembers = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(GetOneProjectManagementTeamMembers.rejected, (state, action) => {
        state.loadingOneProjectManagementTeamMembers = false;
        state.errorOneProjectManagementTeamMembers = action.payload;
      })

      .addCase(
        ValidateProjectManagementTeamMembers.pending,
        (state, action) => {
          state.loadingOneProjectManagementTeamMembersValidate = true;
          state.OneProjectManagementTeamMembersValidate = action.payload;
          state.errorOneOneProjectManagementTeamMembersValidate = null;
        }
      )
      .addCase(
        ValidateProjectManagementTeamMembers.fulfilled,
        (state, action) => {
          state.loadingOneProjectManagementTeamMembersValidate = false;
          state.OneProjectManagementTeamMembersValidate = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        ValidateProjectManagementTeamMembers.rejected,
        (state, action) => {
          state.loadingOneProjectManagementTeamMembersValidate = false;
          state.errorOneOneProjectManagementTeamMembersValidate =
            action.payload;
        }
      );
  },
});
export const { restValidateProjectManagementTeamMembers } =
  OneProjectManagementTeamMembers.actions;
export default OneProjectManagementTeamMembers.reducer;
